<script>
export default {
  name: 'NoData',
  props: {
    msg: {
      type: String,
      default: ''
    }
  }
}
</script>

<template>
  <div class="no-data">
    <el-image class="no-data-img" :src="require('imgs/no-data.webp')" alt="no-data" />
    <p class="no-data-text">{{ msg || '暂无数据' }}</p>
  </div>
</template>

<style lang="scss" scoped>
.no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  .no-data-img {
    width: 314px;
    height: 257px;
  }
  .no-data-text {
    width: 290px;
    font-size: 18px;
    font-weight: bold;
    color: #86BFB0;
    text-align: center;
    margin-top: 10px;
  }
}
</style>
